import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody, Button, Table, Input,  Modal, ModalFooter,  Container } from "reactstrap"
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux"
import { getNewCountry, setSelectedPartnerSuccess} from "store/old/partner/actions";
import LoadingSpinner from "./LoaderPartner";
import store from "../../store/index";
import { useGetRouteTypesQuery } from "../../store/routeType/routeType.api";

const EditPartner = (props) => {

const EditData = props.data;
const EditData_fields = EditData?.message ?? {};
const template = useSelector((state) => state.SourceUpload.templates);
const [selectedTemplate, setTemplate] = useState("")

// const setPartnerName = props.set_partner_name;
// const setPartnerCountry = props.set_partner_country;

const dispatch = useDispatch(); 

// Get route types from API
const { data: routeTypesData, isLoading: isLoadingRouteTypes } = useGetRouteTypesQuery();
const routeTypes = routeTypesData?.routeTypes || [];

// Format route types for react-select
const routeTypeOptions = [
  { id: 0, value: "", label: 'Select Route Type' },
  ...routeTypes.map(type => ({
    id: type.id,
    value: type.id.toString(),
    label: type.name
  }))
];

const countries = useSelector((state) => state.partner.countries);
const countryData = [
  { id:0,value: "", label: 'Select Template'},
  { id:1,value: '1', label: 'Horisen' },
  { id:2,value: '2', label: 'Alaris' },
  { id:3,value: '3', label: 'TelQ - Horisen' },
  { id:4,value: '4', label: 'TelQ - Alaris' },
]
const defaultCountry = countryData?.filter(obj=>obj.value===EditData_fields?.template_id)
const defaultRouteType = routeTypeOptions?.filter(obj=>obj.value===EditData_fields?.route_type_id?.toString())
const [initialState,setInitialState] = useState(1)
const [loading,setLoading] = useState(true)

const pageBody = (
<form>
                      <div className="customer-field-container" >
                        <Row>
                          <Col md="4">
                          <label className="lable-customer">Partner Name</label>
                          </Col>
                          <Col md="8">
                          <Input
                            type="name"
                            className="input-operator"
                            placeholder="Enter the Name"
                            defaultValue={EditData_fields?.partner_name}
                            onChange={(e)=>{
                              // setPartnerName(e.target.value);
                              EditData_fields.partner_name=e.target.value;
                            }}
                          />
                          </Col>
                        </Row>
                        <Row>
                        <Col md="4">
                          <label className="lable-customer">Template</label>
                          </Col>
                          <Col md="8">
                          <Select
                            className="customer-mult-input"
                            //isSearchable={true}
                            name="country"
                            options={countryData}
                            defaultValue = {countryData?.filter((obj) =>{
                             if(obj.value === EditData_fields?.template_id){
                              // console.log(true);
                              return obj;
                             }
                            }) }
                            placeholder="Select Template"
                            onChange={(e)=>{
                              EditData_fields.template_id=e.value;
                            }}
                            
                          />
                          </Col>
                        </Row>
                        
                        {/* Add Route Type dropdown */}
                        <Row>
                          <Col md="4">
                          <label className="lable-customer">Route Type</label>
                          </Col>
                          <Col md="8">
                          <Select
                            className="customer-mult-input"
                            isSearchable={true}
                            isLoading={isLoadingRouteTypes}
                            name="routeType"
                            options={routeTypeOptions}
                            defaultValue={defaultRouteType}
                            placeholder="Route Type"
                            onChange={(e)=>{
                              EditData_fields.route_type_id=e.id;
                            }}
                          />
                          </Col>
                        </Row>
                        
                      </div>
                    </form>
)

if(initialState==1){

  let loadPromise = new Promise(async(resolve,reject)=>{
    store.subscribe(()=>{
      const loadSuccess = store.getState();
      const status = loadSuccess.partner.selectedPartnerSuccess
      if(status == true){
        // console.log(status);
        resolve("Done")
      }
    })
  })
  loadPromise.then(async(msg)=>{
    dispatch(setSelectedPartnerSuccess(false))
    setTimeout(()=>{
    setLoading(false)
    },1000)
  })
}

return (
    <React.Fragment>
        {loading ? <LoadingSpinner/>:pageBody}
    </React.Fragment>
  )
}

export default EditPartner
